export default __webpack_public_path__ + "static/B0253-b652e56d9c5f5386585a529eb7c88e02.png";